import { Platform } from 'react-native'

declare global {
    interface Window {
        google?: {
            maps?: {
                LatLngBounds?: unknown
            }
        }
    }
}

export async function waitForGoogleMapsReady(): Promise<void> {
    if (Platform.OS !== 'web') {
        return
    }

    if (typeof window?.google?.maps?.LatLngBounds === 'function') {
        return
    }

    return new Promise(resolve => {
        const checkGoogleMaps = () => {
            if (typeof window?.google?.maps?.LatLngBounds === 'function') {
                return true
            }
            return false
        }

        const intervalId = setInterval(() => {
            if (checkGoogleMaps()) {
                clearInterval(intervalId)
                resolve()
            }
        }, 100)
    })
}
